import { ComboData } from "./ComboSimulador";

export const ComboPrazo: Array<ComboData> = [
  {
    Name: "120 meses",
    Value: "120"
  },
  {
    Name: "132 meses",
    Value: "132"
  },
  {
    Name: "144 meses",
    Value: "144"
  },
  {
    Name: "156 meses",
    Value: "156"
  },
  {
    Name: "168 meses",
    Value: "168"
  },
  {
    Name: "180 meses",
    Value: "180"
  },
  {
    Name: "192 meses",
    Value: "192"
  },
  {
    Name: "204 meses",
    Value: "204"
  },
  {
    Name: "216 meses",
    Value: "216"
  },
  {
    Name: "228 meses",
    Value: "228"
  },
  {
    Name: "240 meses",
    Value: "240"
  },
  {
    Name: "252 meses",
    Value: "252"
  },
  {
    Name: "264 meses",
    Value: "264"
  },
  {
    Name: "276 meses",
    Value: "276"
  },
  {
    Name: "288 meses",
    Value: "288"
  },
  {
    Name: "300 meses",
    Value: "300"
  },
  {
    Name: "312 meses",
    Value: "312"
  },
  {
    Name: "324 meses",
    Value: "324"
  },
  {
    Name: "336 meses",
    Value: "336"
  },
  {
    Name: "348 meses",
    Value: "348"
  },
  {
    Name: "360 meses",
    Value: "360"
  },
  {
    Name: "372 meses",
    Value: "372"
  },
  {
    Name: "384 meses",
    Value: "384"
  },
  {
    Name: "396 meses",
    Value: "396"
  },
  {
    Name: "408 meses",
    Value: "408"
  },
  {
    Name: "420 meses",
    Value: "420"
  },
  {
    Name: "432 meses",
    Value: "432"
  },
  {
    Name: "444 meses",
    Value: "444"
  },
  {
    Name: "456 meses",
    Value: "456"
  },
  {
    Name: "468 meses",
    Value: "468"
  },
  {
    Name: "480 meses",
    Value: "480"
  },
  {
    Name: "492 meses",
    Value: "492"
  },
  {
    Name: "504 meses",
    Value: "504"
  },
  {
    Name: "516 meses",
    Value: "516"
  },
  {
    Name: "528 meses",
    Value: "528"
  },
  {
    Name: "540 meses",
    Value: "540"
  },
  {
    Name: "552 meses",
    Value: "552"
  },
  {
    Name: "564 meses",
    Value: "564"
  },
  {
    Name: "576 meses",
    Value: "576"
  },
  {
    Name: "588 meses",
    Value: "588"
  },
  {
    Name: "600 meses",
    Value: "600"
  },
];